import { render, staticRenderFns } from "./ARegPeople.vue?vue&type=template&id=33021fcf"
import script from "./ARegPeople.vue?vue&type=script&lang=js"
export * from "./ARegPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports